"use strict";

var _extends = require("/app/react/marvin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/extends");

var _objectSpread = require("/app/react/marvin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _taggedTemplateLiteral = require("/app/react/marvin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _chunkKLNOCL72js = require('./chunk-KLNOCL72.js');

var _chunkNESC3UD7js = require('./chunk-NESC3UD7.js');

var _chunk6R5OOOHCjs = require('./chunk-6R5OOOHC.js');

var _chunkR4XHR6A7js = require('./chunk-R4XHR6A7.js');

var _react = require('react');

var _styledcomponents = require('styled-components');

var _styledcomponents2 = _interopRequireDefault(_styledcomponents);

var _jsxruntime = require('react/jsx-runtime');

var b = _styledcomponents2.default.a.attrs(function (o) {
  return _objectSpread({
    role: "link"
  }, o.disabled ? {
    "aria-disabled": o.disabled
  } : {});
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n"])), function (_ref) {
  var o = _ref.$activeColor,
      d = _ref.$color,
      t = _ref.$disabledColor,
      s = _ref.$focusedColor,
      a = _ref.$hoverColor,
      v = _ref.$isInverse,
      l = _ref.$subtle,
      k = _ref.size,
      i = _ref.theme;
  return _styledcomponents.css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        ", ";\n        ", "\n        font-family: ", ";\n        font-weight: ", ";\n        color: ", ";\n        letter-spacing: 0.5px;\n\n        ", "\n\n        /* anchor tags don't actually support disabled, so we have to use the prop */\n\n        &[aria-disabled='true'] {\n            color: ", ";\n            user-select: none;\n        }\n\n        :not(&[aria-disabled='true']) {\n            cursor: pointer;\n        }\n\n        :not(&[aria-disabled='true']):active {\n            color: ", ";\n\n            ", "\n        }\n\n        :not(&[aria-disabled='true']):not(:active):hover {\n            color: ", ";\n\n            ", "\n        }\n\n        :focus-visible {\n            color: ", ";\n            outline-offset: 2px;\n            ", ";\n\n            ", "\n        }\n\n        ", "\n    "])), _chunkNESC3UD7js.e, _chunk6R5OOOHCjs.f.call(void 0, "color"), i.typography.body.primary.family, i.typography.body.primary.weight, _chunkR4XHR6A7js.a.call(void 0, i.color.text.link, d), l ? _styledcomponents.css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n                  text-decoration: none;\n              "]))) : _styledcomponents.css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n                  text-decoration: underline;\n              "]))), _chunkR4XHR6A7js.a.call(void 0, i.color.text.link, t), _chunkR4XHR6A7js.a.call(void 0, i.color.text.link, o), l && _styledcomponents.css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n                text-decoration: underline;\n            "]))), _chunkR4XHR6A7js.a.call(void 0, i.color.text.link, a), l && _styledcomponents.css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n                text-decoration: underline;\n            "]))), _chunkR4XHR6A7js.a.call(void 0, i.color.text.link, s), v ? _chunkKLNOCL72js.b : _chunkKLNOCL72js.a, l && _styledcomponents.css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n                text-decoration: underline;\n            "]))), function () {
    switch (k) {
      case "xs":
        return _styledcomponents.css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n                        font-size: 12px;\n                        line-height: 18px;\n                    "])));

      case "sm":
        return _styledcomponents.css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n                        font-size: 14px;\n                        line-height: 22px;\n                    "])));

      default:
        return _styledcomponents.css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n                        font-size: 16px;\n                        line-height: 24px;\n                    "])));
    }
  });
});

function r(o) {
  var t = _react.forwardRef.call(void 0, function (_ref2, a) {
    var s = _extends({}, _ref2);

    return _jsxruntime.jsx.call(void 0, b, _objectSpread({
      $activeColor: o.activeColor,
      $color: o.color,
      $disabledColor: o.disabledColor,
      $focusedColor: o.focusedColor,
      $hoverColor: o.hoverColor,
      $isInverse: o.isInverse,
      $subtle: o.subtle,
      ref: a,
      tabIndex: 0
    }, s));
  });

  return t.displayName = o.name, t;
}

var D = r({
  activeColor: "active",
  color: "default",
  disabledColor: "disabled",
  focusedColor: "focused",
  hoverColor: "hover",
  name: "Link"
}),
    P = exports.b = r({
  activeColor: "active",
  color: "weak",
  disabledColor: "disabled",
  focusedColor: "weak",
  hoverColor: "hover",
  name: "WeakLink"
}),
    M = exports.c = r({
  activeColor: "active",
  color: "monochrome",
  disabledColor: "disabled",
  focusedColor: "monochrome",
  hoverColor: "hover",
  name: "MonochromeLink"
}),
    T = exports.d = r({
  activeColor: "inverse",
  color: "inverse",
  disabledColor: "disabled",
  focusedColor: "inverse",
  hoverColor: "inverse",
  isInverse: !0,
  name: "InverseLink"
}),
    R = exports.e = r({
  activeColor: "active",
  color: "default",
  disabledColor: "disabled",
  focusedColor: "focused",
  hoverColor: "hover",
  name: "Link",
  subtle: !0
}),
    W = exports.f = r({
  activeColor: "active",
  color: "weak",
  disabledColor: "disabled",
  focusedColor: "weak",
  hoverColor: "hover",
  name: "WeakLink",
  subtle: !0
}),
    z = exports.g = r({
  activeColor: "active",
  color: "monochrome",
  disabledColor: "disabled",
  focusedColor: "monochrome",
  hoverColor: "hover",
  name: "MonochromeLink",
  subtle: !0
}),
    E = exports.h = r({
  activeColor: "inverse",
  color: "inverse",
  disabledColor: "disabled",
  focusedColor: "inverse",
  hoverColor: "inverse",
  isInverse: !0,
  name: "InverseLink",
  subtle: !0
});
exports.a = D;
exports.b = P;
exports.c = M;
exports.d = T;
exports.e = R;
exports.f = W;
exports.g = z;
exports.h = E;